import { ReactNode, useContext, useRef, useState } from 'react'
import styled from 'styled-components'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import { ExamQuestionSelectOptionType } from '@app.feature/exam/gsat2024-2/types/examQuestionType'
import { useOutSideClick } from 'hooks/useOutSideClick'
import OpenArrowIcon from 'svgIcons/OpenArrowIcon'

interface PredictionDropdownDesktopProps {
  name?: ReactNode
  defaultValue?: string
  options: Array<ExamQuestionSelectOptionType>
  onChange: (value: string) => void
  className?: string
}

const PredictionDropdownDesktop = ({
  name,
  defaultValue,
  options,
  className,
  onChange,
}: PredictionDropdownDesktopProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const { handleCheckReservation } = useContext(ExamContext)
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState<string>()

  const handleSelect = (option: ExamQuestionSelectOptionType) => () => {
    onChange(option.value)
    setSelectedOption(option.label)
    setIsOpen(false)
  }

  const handleToggleList = () => {
    handleCheckReservation({
      onReservated: () => {
        setIsOpen((prev) => !prev)
      },
    })
  }

  const handleOutsideClick = () => {
    setIsOpen(false)
  }

  useOutSideClick({
    ref: dropdownRef,
    isActive: isOpen,
    onOutsideClick: handleOutsideClick,
  })

  return (
    <StyledWrapper className={className}>
      {name && <label>{name}</label>}
      <div className="dropdown" ref={dropdownRef}>
        <div className="dropdown-toggle" onClick={handleToggleList}>
          <span>{selectedOption || defaultValue || options[0]?.label}</span>
          <i>
            <OpenArrowIcon isOpen={isOpen} />
          </i>
        </div>
        {isOpen && (
          <ul>
            {options.map((option) => {
              return (
                <li key={option.value} onClick={handleSelect(option)}>
                  {option.label}
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </StyledWrapper>
  )
}

export default PredictionDropdownDesktop

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > label {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.72px;
    color: #333;
  }

  > .dropdown {
    position: relative;
    > .dropdown-toggle {
      cursor: pointer;
      width: 150px;
      height: 50px;
      border-radius: 8px;
      border: solid 1px #dddddd;
      background-color: #fff;
      padding: 0px 12px 0px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        font-size: 16px;
        font-weight: 500;
        letter-spacing: -0.64px;
        color: #333;
      }

      > i {
        > svg {
          display: block;
        }
      }
    }

    > ul {
      position: absolute;
      z-index: 100;
      top: 55px;
      left: 0px;
      padding: 10px 0px;
      width: 100%;
      border-radius: 8px;
      border: solid 1px #dddddd;
      background-color: #fff;

      > li {
        cursor: pointer;
        width: 100%;
        height: 40px;
        border-bottom: solid 1px #fafafa;
        display: flex;
        align-items: center;
        padding-left: 16px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: -0.64px;
        color: #333;

        &:hover {
          background-color: #fafafa;
        }
      }
    }
  }
`
